import SavingThrowsDesktop from './SavingThrowsDesktop';

export default SavingThrowsDesktop;
export { SavingThrowsDesktop };
